import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import {App} from "./components";
import {NotificationHandler} from "@yakoffice/notification-handler";
import {ModalHandler} from '@yakoffice/custom-modal';
import './index.sass';
import {createRoot} from "react-dom/client";
import {WithAuthentication, WithAuthorisation} from "@yakoffice/with-authorisation";
import {initYakofficeFirebaseApp} from "@yakoffice/yakoffice-firebase";

initYakofficeFirebaseApp();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
      <BrowserRouter>
        <NotificationHandler>
          <ModalHandler>
            <WithAuthentication>
              <WithAuthorisation toolId="sessions">
                <App />
              </WithAuthorisation>
            </WithAuthentication>
          </ModalHandler>
        </NotificationHandler>
      </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
